import NavBar from '../../Layout/NavBar.js'
import Footer from '../../../Components/Layout/Footer';

import { useTheme } from '@mui/material/styles';


import Project from '../../Layout/Project'
import HeaderImage from "../../../img/Gaming/ANewLeaf/HeaderANewLeaf.jpg"
import HeaderLogo from "../../../img/Gaming/ANewLeaf/LogoANewLeaf.png"

import Img_1 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_1.jpg"
import Img_2 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_2.jpg"
import Img_3 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_3.jpg"
import Img_4 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_4.jpg"
import Img_5 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_5.jpg"
import Img_6 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_6.jpg"
import Img_7 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_7.jpg"
import Img_8 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_8.jpg"
import Img_9 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_9.jpg"
import Img_10 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_10.jpg"
import Img_11 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_11.jpg"
import Img_12 from "../../../img/Gaming/ANewLeaf/ImgANewLeaf_12.jpg"

import Video_1 from "../../../video/Projects/Gaming/ANewLeaf/GamePlay.webp"
import Video_2 from "../../../video/Projects/Gaming/ANewLeaf/FarmCustomization.webp"
import Video_3 from "../../../video/Projects/Gaming/ANewLeaf/Inventory.webp"

const ProjectData={
  "headerImage": HeaderImage,
  "headerLogo": HeaderLogo,
  "title": "A New Leaf: Memories",
  "subTitle": "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, ",
  "href":"https://www.kickstarter.com/projects/ironheartstudios/a-new-leaf-memories?lang=it",
  "checkList":[
    {
      "title":"Coding",
      "leftList": [
        "Game Mechanics",
        "Character Customization",
        "Gameplay Editor Tools",
        "Gameplay Feedbacks"
      ],
      "rightList": [
        "Save and load system",
        "Vegetation system",
        "Gameplay actions",
      ]
    },
    {
      "title":"Tech Art",
      "leftList": [
        "Character Shader",
        "Grass Geometry Shader",
        "Terrain Shader",
        "Water Shader"
      ],
      "rightList": [
        "Save and load system",
        "Billboard Shader",
        "Tree Shader",
      ]
    },
  ],
  "images": [
    {
      "title":"Concept Art",
      "subTitle":"Concept Art",
      "images":[
        Img_1,
        Img_2,
        Img_3,
        Img_4,
        Img_5,
      ]
    },
    {
      "title":"Env Art",
      "subTitle":"Concept Art",
      "images":[
        Img_6,
        Img_7,
        Img_8,
        Img_9,
        Img_10,
        Img_11,
        Img_12
      ]
    },
    {
      "title":"Gameplay Video",
      "subTitle":"Concept Art",
      "images":[
        Video_1,
        Video_2,
        Video_3
      ]
    },
  ],

}

function ANewLeafPage(){

  const theme = useTheme();

  return(
    <div
      style={{
        backgroundColor:`${theme.palette.quaternary.main}`
      }}
    >
      <NavBar></NavBar>
      <Project
        data={ProjectData}
      ></Project>
      <Footer></Footer>
    </div>
  )
}
export default ANewLeafPage;